import { graphql } from "gatsby";
import SEO from "../../../../src/components/seo";
import Address from "../../../../src/components/address";
import * as React from 'react';
export default {
  graphql,
  SEO,
  Address,
  React
};